import React, { Component, Suspense } from "react"
import { Container, Col, Button, Row } from "reactstrap"
import { withTranslation } from 'react-i18next'
import { Redirect } from 'react-router-dom'
import { Link } from 'react-router-dom'
import i18n from 'i18next'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import character_2 from "../images/characters/character_2.png"
import axios from "axios"
import consultingReport from "../images/details/consultation-rapport.png"
import kitBiobakery from "../images/details/kit_biobakery_rg.png"
import { FaCheckCircle, FaCreditCard, FaTruck, FaBullseye, FaBrain, FaUserMd, FaAngleDoubleRight } from "react-icons/fa"
import Flag from "react-world-flags"
import NahibuHelmet from '../components/nahibu-helmet'


const WaitingDiv = React.lazy(() => import('../components/waiting'));

class ProductsPage extends Component {

  constructor(props) {
    super(props);
    const t = this.props.t;
    const language = i18n.language ? (i18n.language.startsWith("fr") ? "fr" : i18n.language.startsWith("en") ? "en" : 'es') : undefined;
    this.langSubPath = language === "en" ? "/en" : language === "es" ? "/es" : "";

    
    this.productUrlMap = {
      1: `${this.langSubPath}/${t("path|details-produit")}/kit-nahibu`,
      9: `${this.langSubPath}/${t("path|details-produit")}/consultation`,
    };
    this.state = {
      redirect: null,
      redirectState: {},
      quantity: {
        1: 1,
        9: 1,
      }
    }
    this.handleClick = this.handleClick.bind(this)

  }

  /* Permet de gérer la quantité du produit */
  handleQuantityChange(productId, amount) {
    this.setState((prevState) => {
      const current = prevState.quantity[productId] || 1;
      const newQty = Math.max(1, Math.min(99, current + amount));
      return {
        quantity: {
          ...prevState.quantity,
          [productId]: newQty
        }
      };
    });
  }


  /* Permet d'ajouter un produit au panier et de rediriger vers la page du panier */
  addItemToCart(event, quantity, coupon) {
    if (!quantity || quantity < 1) quantity = 1;
    const t = this.props.t;


    let products = []
    let kit_consult_skus = this.props.config.products.kit_biobakery_rg_consult.skus

    const selectedProductSku = event.target.getAttribute('sku')

    if (kit_consult_skus.includes(selectedProductSku)) {
      products = [
        {
          productSkus: this.props.config.products.kit_biobakery_rg.skus[0],
          quantity: quantity,
        },
        {
          productSkus: this.props.config.products.consultation_solo.skus[0],
          quantity: quantity,
        },
      ]
    } else {
      products = [
        {
          productSkus: selectedProductSku,
          quantity: quantity,
        },
      ]
    }

    // Redirect to cart
    this.setState({
      redirect: this.langSubPath + "/" + t("path|panier") + "/",
      redirectState: {
        products: products,
        coupon: coupon,
      }
    })
  }





  backToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  handleClick(event, quantity, coupon) {

    // add item to cart and redirect to cart page
    this.addItemToCart(event, quantity, coupon)

    if (this.props.auth.logged) {
      const data = {
        email: this.props.auth.user.email,
        sendinblue_list: "Abandon panier"
      }

      const requestUrl = this.props.config.wooApiUrl + "/register-list"
      axios.post(requestUrl, data).then(response => {
        this.setState({
          email: "",
          success: true,
          error: false,
          waiting: false,
        })
      }).catch(error => {
        // manage errors
        if (error.response) {
          console.error("Response error", error.response.data.data.message)
        } else if (error.request) {
          console.error("Request error", error.request)
        } else {
          console.error("Error", error.message)
        }

        this.setState({
          success: false,
          error: true,
          waiting: false,
        })
      })
      event.preventDefault()
    }

  }


  render() {
    const t = this.props.t

    this.products = [
      {
        id: 1,
        name: t("nos-produits|KIT NAHIBU"),
        price: "199.00 €",
        oldPrice: "249.99 €",
        sku: this.props.config.products.kit_biobakery_rg.skus[0],
        image: kitBiobakery,
        width: "60%",
        infos: [
          { icon: <FaCheckCircle />, text: t("nos-produits|Recommandé par les professionnels du bien-être") },
          { icon: <FaCreditCard />, text: t("nos-produits|Payez en 3 échéances de 66,33€ sans frais") },
          { icon: <FaTruck />, text: t("nos-produits|Livraison et retour du kit gratuits (France uniquement)") },
          { icon: <Flag code="FR" alt="FR" />, text: t("nos-produits|100% Français") },
        ],
        link: this.productUrlMap[1],
        buttonLabel: t("nos-produits|Commander mon kit"),
      },
      {
        id: 9,
        name: t("nos-produits|CONSULTATION"),
        price: "50.00 €",
        sku: this.props.config.products.consultation_solo.skus[0],
        image: consultingReport,
        width: "54.5%",
        infos: [
          { icon: <FaUserMd />, text: t("nos-produits|Entretien personnalisé de 30 minutes") },
          { icon: <FaBrain />, text: t("nos-produits|Compréhension claire de vos résultats") },
          { icon: <FaBullseye />, text: t("nos-produits|Conseils concrets et adaptés à votre profil") },
          { icon: <Flag code="FR" alt="FR" />, text: t("nos-produits|100% Français") },
        ],
        link: this.productUrlMap[9],
        buttonLabel: t("nos-produits|Réserver une consultation"),
      },
    ];


    if (this.state.redirect) {
      return <Redirect to={{
        pathname: this.state.redirect,
        state: this.state.redirectState,
      }} />
    }

    if (this.props.waitingStore) {
      return (<Suspense fallback={<div></div>}><WaitingDiv center={true} waiting={this.props.waitingStore} /></Suspense>)
    }
    return (
      <>
        <NahibuHelmet
          canonicalUrl = {'https://nahibu.me'+this.langSubPath+'/'+t('canonical-url|nos-produits')+'/'}
          title={t("product|Analyse Microbiote Intestinal : Kit Test Complet à Domicile") + " | Nahibu"}
          description={t("product|Analysez votre microbiote intestinal chez vous avec le kit Nahibu. Résultats détaillés, conseils adaptés, analyse 100 % française.")}
        />


        <Container className="my-md-5 my-2 py-4 pb-5 pb-md-0">
          <h1 className="second-title dark-blue mb-3 mt-4 mt-md-0">{t("nos-produits|Nos produits")}<LazyLoadImage className="pb-5 ml-3" alt={t("buy|Kit d'analyse du microbiote intestinal Nahibu")} src={character_2} width="28px" /></h1>
          <Row>
            {this.products.map((product, index) => (
              <Col key={product.id} md={4} sm={12} className="mt-4 d-flex flex-column justify-content-between product-border"><Link className="mb-3 w-100 nav-link h-100 hover-opacity rounded d-flex flex-column" to={product.link}>
                <div className="flex-grow-1">
                  <div className="w-100 center">
                    <LazyLoadImage alt={product.name} src={product.image} width={product.width} />
                  </div>
                  <p className="pt-2 mb-0 dark-blue"><b>{product.name}</b></p>
                  <p className="pt-2 mb-0 dark-blue">
                    <b>{product.price}</b>
                    {product.oldPrice && <span className="old-price-gray pl-4">{product.oldPrice}</span>}
                  </p>

                  <div className="my-3 text-justify">
                    {product.infos.map((info, i) => (
                      <p key={i} className="dark-blue mt-0 mb-1 d-flex align-items-center small">
                        {React.cloneElement(info.icon, { className: "mr-2 icon-fix-small" })}
                        {info.text}
                      </p>
                    ))}
                  </div>
                </div>

                <div className="text-center mt-3 mb-2 small font-italic dark-blue">
                  {t("nos-produits|Cliquez pour plus d'informations")}
                </div>
              </Link>



                <div className="d-flex flex-column">
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <Button
                      onClick={(e) => this.handleClick(e, this.state.quantity[product.id], null)}
                      sku={product.sku}
                      className="font-weight-light btn-pricing-slider-2"
                    >
                      <FaAngleDoubleRight className="pr-2 icon-fix-small fix-icon-pad" />{product.buttonLabel}
                    </Button>
                    <div className="d-flex align-items-center pr-2">
                      <Button size="sm" onClick={() => this.handleQuantityChange(product.id, -1)} className="btn-quantity">-</Button>
                      <span className="mx-2">{this.state.quantity[product.id] || 1}</span>
                      <Button size="sm" onClick={() => this.handleQuantityChange(product.id, 1)} className="btn-quantity">+</Button>
                    </div>

                  </div>
                </div>
              </Col>
            ))}
          </Row>

        </Container>
      </>
    )
  }
}
export default withTranslation()(ProductsPage)
